import {HttpSvcFactory} from '../../services/HttpSvc';
import {AuthenticationSvc} from '../../services/AuthenticationSvc';
import {TranslateSvc} from '../../services/TranslateSvc';
import {Utils} from '../../underscore-extensions';
import {SubscriptionSvc} from './SubscriptionSvc';

export interface TypeformParams extends ng.ui.IStateParamsService {
    userid: string;
}

export class TypeformSvc {
    showDeletedModal = false;
    private userId: string;

    constructor(private $state: ng.ui.IStateService,
                private $stateParams: TypeformParams,
                private $q: ng.IQService,
                private TranslateSvc: TranslateSvc,
                private subscriptionSvc: SubscriptionSvc,
                private AuthenticationSvc: AuthenticationSvc,
                private HttpSvc: HttpSvcFactory) {
        this.userId = this.$stateParams.userid;
    }

    openTypeFormCancel() {
        const formId = this.getProduct() === 'wave' ? 'K6si1N' : 'oOu1yB';
        const typeformUrl = this.getUrl('downgrade', formId);

        window.open(typeformUrl, '_self');
    }

    openTypeFormDelete() {
        const formId = this.getProduct() === 'wave' ? 'W3TtpN' : 'OcPZVX';
        const typeformUrl = this.getUrl('delete', formId);

        this.deleteAccountRequest().then(() => window.open(typeformUrl, '_self'));
    }

    deleteAccountRequest() {
        return this.HttpSvc('profile')
            .secureDelete()
            .then((data: ApiError) => {
                return Utils.isApiError(data)
                    ? this.$q.reject(data.errorMessage)
                    : data;
            })
            .then(() => this.AuthenticationSvc.logout())
            .catch((err: string) => _.notification.showError(err));
    }

    private getProduct() {
        return Utils.getProduct().toLowerCase();
    }

    private getUrl(action: 'downgrade' | 'delete', typeformId: string) {
        let url = `${location.host}/${this.getProduct()}`;
        if (action === 'downgrade') {
            url = `${url}/settings/subscription`;
        }

        return `https://animatron.typeform.com/to/${typeformId}?email=${options.user.email}`;
    }

    private isLogged(): boolean {
        if (!this.AuthenticationSvc.loggedIn) {
            this.openModalLogin();
            return false;
        }

        if (this.userId !== options.user.userId) {
            this.AuthenticationSvc.logout();
            this.openModalLogin();
            return false;
        }

        return true;
    }

    private openModalLogin() {
        const currentUrl = `${this.$state.current.url}=${this.$stateParams.userid}`;
        const message = this.TranslateSvc.get('login.redirect-email');

        this.$state
            .go(`${this.getProduct()}-landing`)
            .then(() => setTimeout(() => this.AuthenticationSvc.toggleLoginModal(currentUrl, message), 0));
    }
}

angular.module('animatronApp.settings').service('typeformSvc', TypeformSvc);


// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/services/TypeformSvc.ts